import { render, staticRenderFns } from "./salesperson_dashboard.vue?vue&type=template&id=7653802d&scoped=true&"
import script from "./salesperson_dashboard.vue?vue&type=script&lang=js&"
export * from "./salesperson_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./salesperson_dashboard.vue?vue&type=style&index=0&id=7653802d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7653802d",
  null
  
)

export default component.exports